import { AuditFilters } from '../../../components/modals/admin/AuditFiltersModal'
import {
	CustomColumnFilter,
	OrderByType,
} from '../../../pages/Workspace/components/interfaces.table'
import { GetAuditEventsParamsProps } from '../../api/types/audit.interfaces'
import { mapColumnFiltersToQuery } from './filtersMapper'

export const setOrderDirection = (
	orderDirection: 'asc' | 'desc' | null | undefined,
	orderBy?: OrderByType,
): number | null => {
	if (orderDirection === 'asc') {
		return orderBy === 'processingStatus' ? -1 : 1
	}
	if (orderDirection === 'desc') {
		return orderBy === 'processingStatus' ? 1 : -1
	}
	return null
}

export const buildFiltersParams = (columnFilters?: CustomColumnFilter[]) => {
	if (!columnFilters || !columnFilters.length) return {}

	const queryParams: Record<string, string> = {}

	mapColumnFiltersToQuery(columnFilters).forEach((filter, index) => {
		let filterValue = filter.value.toString()

		// If this is a filter by category or subcategory and the value is general_document, send empty string instead
		if (
			(filter.by === 'category' || filter.by === 'subcategory') &&
			filterValue === 'general_document'
		) {
			filterValue = ''
		}

		if (filter.by === 'type' && filter.value === 'file') {
			filterValue = '[^Folder]'
		}

		queryParams[`filter[${index}].by`] = filter.by
		queryParams[`filter[${index}].type`] = filter.type.toString()
		queryParams[`filter[${index}].value`] = filterValue
	})

	return queryParams
}

export const buildEventFiltersParams = (
	filters?: GetAuditEventsParamsProps['filters'],
) => {
	if (!filters) return {}

	const params: Record<string, any> = {}

	if (filters.startDate) params.startDate = filters.startDate
	if (filters.endDate) params.endDate = filters.endDate

	filters.userId?.forEach((id, i) => {
		params[`userId[${i}]`] = id
	})

	filters.objectId?.forEach((id, i) => {
		params[`objectId[${i}]`] = id
	})

	filters.categoryId?.forEach((id, i) => {
		params[`categoryId[${i}]`] = id
	})

	return params
}
